import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import { ReactComponent as DownloadIcon } from '../../../../assets/download.svg'
import { ReactComponent as Arrow } from '../../../../assets/arrow-left.svg'

import './index.scss'
const AcDocs = observer(() => {
  const content = ContentState.acdocs
  if (!content) return <></>
  return (
    <section className="ac-docs">
      {content.list.map((li: any, i: number) => (
        <div
          className="ac-docs__item"
          key={i}
          onClick={() => {
            window.open(li.link, '__blank')
          }}
        >
          <a className="ac-docs__item-btn" href={li.link} download>
            <DownloadIcon />
          </a>
          <div className="ac-docs__item-title">{li.title}</div>
          <div className="ac-docs__item-next">
            <Arrow />
          </div>
        </div>
      ))}
    </section>
  )
})

export default AcDocs
